module.exports = __webpack_public_path__ + "static/img/14000592.69c7131c.png";